export enum IntegrationType {
  CustomerIntegration = 'CUSTOMER_INTEGRATION',
  FleetIntegration = 'FLEET_INTEGRATION',
}
